module.exports = __webpack_public_path__ + "static/media/16PerformancePhotos.1dfde963.jpeg";